import type { DefaultAssignee } from '../../common/model/types.tsx';
import { createOptions } from '../../common/rest/index.tsx';

export type CreateRequestPayload = {
	name: string;
	description: string | undefined;
	leadAccountId?: string | undefined;
	assigneeType: DefaultAssignee;
	project: string;
	projectId: number;
};

export const getUrl = () => '/rest/api/2/component';

export const create = (payload: CreateRequestPayload): Promise<Response> =>
	fetch(getUrl(), createOptions('POST', payload));
